import styled from 'styled-components';
import { cornerStyleInterpolationFactory } from '../lib/cornerStyle';

declare module '@nucleus/post-theme-elements' {
  interface PostThemeElementsTheme {
    PostExpandedViewCard?: {
      background?: string;
      color?: string;
    };
  }
}

export const PostExpandedViewCard = styled.div`
  border-radius: ${cornerStyleInterpolationFactory({
    square: '0px',
    rounded: '18px',
    pill: '40px',
  })};
  background: ${({ theme }) => theme._postThemeElements.PostExpandedViewCard?.background};
  color: ${({ theme }) => theme._postThemeElements.PostExpandedViewCard?.color};
  max-width: 1200px;
  margin-left: auto;
  margin-right: auto;
  box-shadow: 0 53px 77px 0 rgba(0, 0, 0, 0.24);
`;
